import { types, flow } from "mobx-state-tree";
import CONSTANTS from "const/constants";

import { UserCredentialBaseStore } from "./user-credential-base-store";

const { CREDENTIAL_TYPE_LABELS, PLATFORM_TYPES, INSTAGRAM_OPTIONS } = CONSTANTS;
const DEFAULT_SHARE_TYPE = INSTAGRAM_OPTIONS.FEED;

const model = {
    instagramDisplayName: types.maybeNull(types.string),
    instagramProfilePictureUrl: types.maybeNull(types.string),
    instagramUsername: types.maybeNull(types.string),
    instagramProfileUrl: types.maybeNull(types.string),
    instagramAccountId: types.maybeNull(types.string),
    instagramLinkedFacebookPageId: types.maybeNull(types.string)
};

const volatile = (self) => {
    const __name__ = self.name;
    const __profileImage__ = self.profileImage;

    return {
        name: self?.instagramDisplayName ?? __name__,
        profileImage: self?.instagramProfilePictureUrl ?? __profileImage__,
        typeLabel: CREDENTIAL_TYPE_LABELS.INSTAGRAM,
        platformType: PLATFORM_TYPES.INSTAGRAM,
        shareKey: `shareViaInstagramCount`,
        shareType: self?.shareType ?? DEFAULT_SHARE_TYPE
    };
};

const views = (self) => {
    return {
        getShareType: function () {
            return self.shareType;
        }
    };
};

const viewOverrides = (self) => {
    return {
        isSocialMedia() {
            return true;
        }
    };
};

const actions = (self) => {
    const __onShareSuccessful__ = self.onShareSuccessful;

    return {
        onShareSuccessful(response) {
            return __onShareSuccessful__.call(self, self.shareKey, response);
        },

        setShareType(shareType = DEFAULT_SHARE_TYPE) {
            self.shareType = shareType;
        }
    };
};

const asyncActions = (self) => {
    const __share__ = self.share;

    return {
        /**
         * Overrides the base share method to add facebook specific share data
         * @async
         * @param {String} shareId
         * @param {object} data
         * @return {ShareObject | Error}
         */
        share: flow(function* share(shareId, data) {
            if (App.Models.user.socialCredentials.getEnabledCredentials()) {
                if (self.getShareType() === INSTAGRAM_OPTIONS.REEL) {
                    return yield __share__.call(self, shareId, {
                        ...data,
                        reel: true
                    });
                }
                if (self.getShareType() === INSTAGRAM_OPTIONS.STORY) {
                    return yield __share__.call(self, shareId, {
                        ...data,
                        story: true
                    });
                }
            }
            return yield __share__.call(self, shareId, data);
        })
    };
};

const _UserCredentialInstagramStore = types
    .model(`UserCredentialInstagram`, model)
    .volatile(volatile)
    .views(views)
    .views(viewOverrides)
    .actions(actions)
    .actions(asyncActions);

export const UserCredentialInstagramStore = types
    .compose(UserCredentialBaseStore, _UserCredentialInstagramStore)
    .named(`UserCredentialInstagramStore`);
